module.exports = __webpack_public_path__ + "static/media/status0.1717708a.png";